import React, { useEffect, useState } from "react"
import Parser from "rss-parser"
import { WhiteDiv } from "./whitediv"
interface BellBoardProps {
  numItems: number
}
export const BellBoard: React.FC<BellBoardProps> = ({ numItems }) => {
  const [items, setItems] = useState([])
  useEffect(() => {
    let parser = new Parser()
    let mounted = true
    parser.parseURL(
      "https://cors-anywhere.herokuapp.com/http://bb.ringingworld.co.uk/rss.php?id=1710",
      (err, feed) => {
        if (mounted && feed) {
          setItems(
            feed.items.slice(0, numItems).map(entry => (
              <p key={entry.content} style={{ fontSize: "0.75rem" }}>
                <a href={entry.link}>{entry.title}</a>
                <br />
                {entry.content}
              </p>
            ))
          )
        }
      }
    )
    return () => {
      mounted = false
    }
  })
  return (
    <WhiteDiv style={{ marginBottom: "1rem" }}>
      <h3>Recent Ringing</h3>
      {items}
    </WhiteDiv>
  )
}
